import React from 'react'
import { Box, Grid, IconButton } from '@mui/material'
import TableData from '../atoms/table/TableData'
import KebabMenu from '../dataGrid/KebabMenu'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import CommonModal from '../atoms/modal/CommonModal'
import ButtonCustom from '../atoms/button/ButtonCustom'
import InputCustom from '../atoms/input/InputCustom'
import { useDispatch, useSelector } from 'react-redux'
import { closeModal, openModal } from '../../features/commonSlice'
import CommonDeleteModal from '../atoms/modal/CommonDeleteModal'
import { deleteCategoryLineItem, updateCategoryLineItem } from '../../features/kazooEventSlice'
import { useParams } from 'react-router-dom'
import { useState } from 'react'
import SelectCustom from '../atoms/select/SelectCustom'
import { toastHelper } from '../../util/toastHelper'
import DateCustom from '../atoms/input/DateCustom'

export default function CategoryTable({ rows, category, vendors }) {
	const dispatch = useDispatch()
    const { kazooId } = useParams()

	// kebab menu
	const [menuAnchor, setMenuAnchor] = React.useState(null)
	const [menuRow, setMenuRow] = React.useState(null)
	const modal = useSelector((s) => s.common.modal)
	const openMenu = (e, row) => {
		e.stopPropagation()
		setMenuAnchor(e.currentTarget)
		setMenuRow(row)
	}
	const closeMenu = () => {
		setMenuAnchor(null)
		setMenuRow(null)
	}

    const [selectedLineItem, setSelectedLineItem] = useState({})

	const columns = [
		{
			field: 'item',
			headerName: 'Item',
			flex: 1,
			minWidth: 100,
		},
		{
			field: 'vendor',
			valueGetter: (value) => {
				return value?.name || 'None'
			},
			headerName: 'Vendor',
			flex: 1,
			minWidth: 100,
		},
		{
			field: 'paid',
			valueGetter: (value) => {
				return `$${value.toLocaleString()}`
			},
			headerName: 'Paid',
			flex: 1,
			minWidth: 100,
		},
		{
			field: 'remaining',
			valueGetter: (value, row) => {
				return `$${(row.total - row.paid).toLocaleString()}`
			},
			headerName: 'Remaining',
			flex: 1,
			minWidth: 100,
		},
		{
			field: 'total',
			valueGetter: (value) => {
				return `$${value.toLocaleString()}`
			},
			headerName: 'Total',
			flex: 1,
			minWidth: 100,
		},
		{
			field: 'menu',
			headerName: '',
			sortable: false,
			filterable: false,
			width: 64,
			align: 'right',
			renderCell: (params) => (
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'flex-end',
						width: '100%',
						height: '100%',
					}}
				>
					<IconButton
						data-cy="kebab"
						size="small"
						onClick={(e) => openMenu(e, params.row)}
						sx={{ p: 0.5 }}
					>
						<img src="/images/more.svg" alt="" />
					</IconButton>
				</Box>
			),
		},
	]

	const handleClose = () => {
		dispatch(closeModal())
	}

    const handleDeleteLineItem = () => {
        dispatch(deleteCategoryLineItem({
            kazooId,
            category,
            lineItemId: selectedLineItem._id
        }))
        dispatch(closeModal())
    }

    const handleEditLineItem = () => {
        if(!selectedLineItem.item){
            return toastHelper('Must include item name', 'error')
        }

        if(selectedLineItem.total < selectedLineItem.paid){
            return toastHelper('Total amount cannot be less than paid amount', 'error')
        }

        if(!selectedLineItem.dueDate) {
            return toastHelper('Must choose a due date', 'error')
        }

        if(selectedLineItem.total <= 0){
            return toastHelper('Total amount must be greater than 0', 'error')
        }

        if(selectedLineItem.paid < 0) {
            return toastHelper('Paid amount must be positive', 'error')
        }

        dispatch(updateCategoryLineItem({
            kazooId,
            category,
            lineItem: selectedLineItem
        }))
        handleClose()
    }

	return (
		<div style={{ gridTemplateColumns: '1fr 1fr' }}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					// height: 'calc(100vh - 420px)',
					// height: '100%',
					// minHeight: 200,
					'@media (max-width: 900px)': {
						// height: 'calc(100vh - 390px)',
					},
				}}
			>
				<Box sx={{ flex: 1, minHeight: 0 }}>
					<TableData
						rows={rows}
						columns={columns}
						height="300px"
						checkboxSelection={false}
						getRowId={(row) => row._id}
						sx={
							{
								// height: 'calc(100dvh - 200px)',
								// '@media (max-width: 768px)': {
								// 	height: 'calc(100dvh - 260px)',
								// },
							}
						}
					/>
					<KebabMenu
						anchorEl={menuAnchor}
						open={Boolean(menuAnchor)}
						onClose={closeMenu}
						items={[
							{
								key: 'Edit',
								label: 'Edit',
								icon: (
									<>
										<img
											src="/images/edit-icon.svg"
											alt="edit-icon.svg"
										/>
									</>
								),
								onClick: () => {
                                    setSelectedLineItem(menuRow)
                                    dispatch(openModal('editModal'))
                                },
							},
							{
								key: 'delete',
								label: 'Delete',
								icon: <DeleteOutlineIcon fontSize="small" />,
								onClick: () =>{
                                    setSelectedLineItem(menuRow)
									dispatch(openModal('removeLineItem'))
                                },
								color: 'error.main',
							},
						]}
					/>
				</Box>
			</Box>

			<CommonModal
				open={modal === 'editModal'}
				handleClose={handleClose}
				heading="Edit Line Item"
				footerContent={
					<>
						<ButtonCustom variant="outlined" onClick={handleClose}>
							Cancel
						</ButtonCustom>
						<ButtonCustom onClick={handleEditLineItem}>
							Save
						</ButtonCustom>
					</>
				}
			>
				<form>
					<Grid container spacing={1.5}>
						<Grid size={{ xs: 12, md: 12 }}>
							<InputCustom
								label="Item Name"
                                value={selectedLineItem?.item}
                                data={selectedLineItem}
                                setDataFunction={setSelectedLineItem}
								type="text"
								name="item"
								placeholder="Item Name"
							/>
						</Grid>
						<Grid size={{ xs: 12, md: 12 }}>
							<SelectCustom
                                label='Vendor'
                                defaultValue={selectedLineItem?.vendor?.name || selectedLineItem?.vendor?.email}
                                options={[...vendors, {label: 'None', value: undefined}]}
                                renderValueAsLabel={true}
                                setDataFunction={(selectedOption) => {
                                    let vendor = {
                                        name: selectedOption.label
                                    }
                                    if(selectedOption.hasAccount){
                                        vendor.vendorId = selectedOption.value
                                    } else {
                                        vendor.email = selectedOption.value
                                    }
                                    setSelectedLineItem({
                                        ...selectedLineItem,
                                        vendor
                                    })
                                }}
                            />
						</Grid>
						<Grid size={{ xs: 12, md: 12 }}>
                            <DateCustom
                                data_cy='date'
								name="dueDate"
								value={selectedLineItem?.dueDate}
								data={selectedLineItem}
								setDataFunction={setSelectedLineItem}
                                label='Due date'
							/>
						</Grid>
						<Grid size={{ xs: 12, md: 6 }}>
							<InputCustom
								label="Total"
                                value={selectedLineItem?.total}
                                data={selectedLineItem}
                                setDataFunction={setSelectedLineItem}
								type="number"
								name="total"
							/>
						</Grid>
						<Grid size={{ xs: 12, md: 6 }}>
							<InputCustom
								label="Paid"
                                value={selectedLineItem?.paid}
                                data={selectedLineItem}
                                setDataFunction={setSelectedLineItem}
								type="number"
								name="paid"
							/>
						</Grid>
					</Grid>
				</form>
			</CommonModal>
			<CommonDeleteModal
				open={modal === 'removeLineItem'}
				handleClose={() => dispatch(closeModal())}
				heading="Remove Line Item"
				footerContent={
					<>
						<ButtonCustom
							variant="outlined"
							type="button"
							size="lg"
							onClick={() => dispatch(closeModal())}
						>
							Cancel
						</ButtonCustom>
						<ButtonCustom
							variant="destructive"
							size="lg"
							onClick={handleDeleteLineItem}
						>
							Remove
						</ButtonCustom>
					</>
				}
			></CommonDeleteModal>
		</div>
	)
}
